module.exports = __webpack_public_path__ + "img/744.0ce53664.jpg";